import React from 'react'
import Header from '../components/Header'
import Signin from '../components/Signin'
export default function Loginpage() {
  return (
    <>
    <Header/>
    <Signin/>
    </>
  )
}
